//#region redux
import { selfInvoiceSnoozed } from "store/actions/selfInvoiceActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { useSnoozeAction } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useSelfInvoiceSnoozeAction(id: string, markAsDone: (id: string) => void) {
  const dispatch = useDispatch();

  const onSnoozeInvoiceSuccess = () => {
    dispatch(selfInvoiceSnoozed(id));
    markAsDone(id);
  };

  const { snoozeAction } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.SelfInvoice,
    onSnoozeInvoiceSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Invoice)
  );

  return snoozeAction;
}

export default useSelfInvoiceSnoozeAction;
